import React from 'react'

import AmenitiesSidebar from './sidebar.component'
import AmenitiesSidebarV2 from './sidebarV2.component'

interface AmenitiesContainer {
    amenitiesSidebarRef: any
}

interface Props {
    isAmenities: boolean,
    amenitiesData: any,
    colorsData: any,
    handleamenitiesMenySelection: any,
    handleamenitiesFilter: any,
    handleamenitiesAttributesFilter: any,
    handleMenuSelection: any,
    amenitiesFilterId: string,
    amenitiesFilterAttributeId: any,
    handleOpenAmenitiesSpin: any,
    handleCloseAmenitieSpin: any,
    typeAmenities: any
}

interface State {
    show: boolean
}

class AmenitiesContainer extends React.Component<Props,State>{
    constructor(props: Props){
        super(props)
        this.state = {
            show: this.props.isAmenities
        }
        this.amenitiesSidebarRef = React.createRef()
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if(prevProps.isAmenities !== this.props.isAmenities){
            this.setState({
                show: this.props.isAmenities
            }, () => {
                if(this.props.isAmenities === false){
                    //this.props.handleMenuSelection('')
                    this.props.handleCloseAmenitieSpin()
                }
            })
        }
    }

    render(): React.ReactNode {
        
        return(
            <div className={this.props.isAmenities ? 'amenities-container fade-in':'amenities-container fade-out'}>
                {
                    this.props.amenitiesData && !this.props.typeAmenities ?
                    <AmenitiesSidebar
                        amenitiesData={this.props.amenitiesData}
                        colorsData={this.props.colorsData}
                        handleamenitiesMenySelection = {this.props.handleamenitiesMenySelection}
                        handleamenitiesFilter = {this.props.handleamenitiesFilter}
                        handleMenuSelection = {this.props.handleMenuSelection}
                        amenitiesFilterId = {this.props.amenitiesFilterId}
                        handleOpenAmenitiesSpin = {this.props.handleOpenAmenitiesSpin}
                        handleCloseAmenitieSpin = {this.props.handleCloseAmenitieSpin}
                        isAmenities = {this.props.isAmenities}
                    />: this.props.amenitiesData && this.props.typeAmenities ? 
                    <AmenitiesSidebarV2
                        amenitiesData={this.props.amenitiesData}
                        colorsData={this.props.colorsData}
                        handleamenitiesMenySelection = {this.props.handleamenitiesMenySelection}
                        handleamenitiesFilter = {this.props.handleamenitiesFilter}
                        handleamenitiesAttributesFilter = {this.props.handleamenitiesAttributesFilter}
                        handleMenuSelection = {this.props.handleMenuSelection}
                        amenitiesFilterId = {this.props.amenitiesFilterId}
                        amenitiesFilterAttributeId = {this.props.amenitiesFilterAttributeId}
                        handleOpenAmenitiesSpin = {this.props.handleOpenAmenitiesSpin}
                        handleCloseAmenitieSpin = {this.props.handleCloseAmenitieSpin}
                        isAmenities = {this.props.isAmenities}
                    />
                     : null
                }
            </div>
        )
    }
}

export default AmenitiesContainer